{
  "A": {
    "long": "Attivo",
    "short": "attivo"
  },
  "BD": {
    "long": "Batteria",
    "short": "batteria scarica"
  },
  "BES": {
    "long": "L'alimentazione esterna e la batteria interna sono criticamente scariche. Il dispositivo si spegnerà presto",
    "short": "la batteria ha bisogno di essere spenta"
  },
  "BL": {
    "long": "Batteria scarica",
    "short": "Basso"
  },
  "BN": {
    "long": "La carica della batteria non è bassa",
    "short": "OK"
  },
  "C": {
    "long": "Interruttore chiuso",
    "short": "Chiuso"
  },
  "DVS": {
    "long": "Il dispositivo è in modalità sospensione",
    "short": "addormentato"
  },
  "DVSA": {
    "long": "Sospensione del dispositivo interrotta",
    "short": "modalità sospensione interrotta"
  },
  "DVSQ": {
    "long": "Dispositivo in stand-by a breve",
    "short": "modalità di sospensione in avvio"
  },
  "DVSW": {
    "long": "Il dispositivo si è riattivato",
    "short": "appena svegliato"
  },
  "FLF": {
    "long": "Fluente",
    "short": "che scorre"
  },
  "FLN": {
    "long": "Non scorre",
    "short": "non scorre"
  },
   "FLOV": {
    "long": "Scorrere velocemente",
    "short": "scorrere velocemente"
  },
  "GDSBL": {
    "long": "Posizione disabilitata",
    "short": "disabile"
  },
  "GERR": {
    "long": "Errore del chip GPS",
    "short": "errore"
  },
  "GLK": {
    "long": "Precisione della posizione decente",
    "short": "bloccato"
  },
  "GOFF": {
    "long": "Chip GPS spento",
    "short": "spento"
  },
  "GST": {
    "long": "Ottima precisione della posizione",
    "short": "serratura forte"
  },
  "GULK": {
    "long": "Nessuna precisione della posizione",
    "short": "sbloccato"
  },
  "HHI": {
    "long": "Alto",
    "short": "alto"
  },
  "HNO": {
    "long": "Normale",
    "short": "normale"
  },
  "HLO": {
    "long": "Basso",
    "short": "Basso"
  },
  "I": {
    "long": "Inattivo",
    "short": "inattivo"
  },
  "MA": {
    "long": "Nessun magnete",
    "short": "nessun magnete rilevato"
  },
  "MP": {
    "long": "Magnete rilevato",
    "short": "rilevato"
  },
  "NC": {
    "long": "Dispositivo non configurato",
    "short": "non configurato"
  },
  "NONE": {
    "long": "Nessuno",
    "short": "Nessuno"
  },
  "NSIG": {
    "long": "Il dispositivo non ha segnale cellulare",
    "short": "nessun segnale"
  },
  "OFF": {
    "long": "Spento",
    "short": "spento"
  },
  "ON": {
    "long": "SU",
    "short": "SU"
  },
  "PHI": {
    "long": "Alta pressione",
    "short": "alto"
  },
  "PLO": {
    "long": "Bassa pressione",
    "short": "Basso"
  },
  "POV": {
    "long": "Sopra la soglia",
    "short": "Sopra"
  },
  "RE": {
    "long": "Estensione per eseguire la posizione di inizio",
    "short": "estendere"
  },
  "RR": {
    "long": "Ritraendo",
    "short": "ritrattare"
  },
  "RS": {
    "long": "Fermato",
    "short": "fermato"
  },
  "THI": {
    "long": "Alto",
    "short": "alto"
  },
  "TNO": {
    "long": "Normale",
    "short": "normale"
  },
  "TLO": {
    "long": "Basso",
    "short": "Basso"
  },
  "VFDOF": {
    "long": "VFD spento",
    "short": "Spento"
  },
  "VFDOV": {
    "long": "Oltre la velocità massima",
    "short": "Oltre il massimo"
  },
  "VFDPIDT": {
    "long": "Punto di riferimento di tracciamento",
    "short": "Monitoraggio"
  },
  "VFDRP": {
    "long": "Rampa VFD",
    "short": "Rampa"
  },
  "VFDST": {
    "long": "VFD acceso",
    "short": "SU"
  },
  "VFDUN": {
    "long": "Sotto la velocità minima",
    "short": "Sotto il minimo"
  },
  "WF": {
    "long": "Muovendosi velocemente",
    "short": "veloce"
  },
  "WL": {
    "long": "Muovendosi lentamente",
    "short": "lento"
  },
  "WS": {
    "long": "Fermato",
    "short": "fermato"
  },
  "WUNK": {
    "long": "Sconosciuto",
    "short": "Sconosciuto"
  }
}
